import { render, staticRenderFns } from "./BlockingRecordComponent.vue?vue&type=template&id=ed9e4a30&scoped=true"
import script from "./BlockingRecordComponent.vue?vue&type=script&lang=js"
export * from "./BlockingRecordComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9e4a30",
  null
  
)

export default component.exports